module.exports = __webpack_public_path__ + "models/tutor1.dc37319.atlas";